<template>
  <ais-stats class="search-pagination text-sm c-gray-800">
    <template v-slot="{ nbPages, nbHits, page }">
      <span>{{ nbHits | comma }} {{ nbHits === 1 ? 'Result' : 'Results' }}</span>
      <ais-pagination v-if="nbPages > 1" class="search-pagination-buttons">
        <template
          v-slot="{ currentRefinement, isFirstPage, isLastPage, refine, createURL }"
        >
          <a
            :href="createURL(currentRefinement - 1)"
            @click.prevent="refine(currentRefinement - 1)"
            :class="['search-pagination-prev', isFirstPage && 'disabled']"
          >
            <SloIcon name="ArrowLeft" size="sm" />
          </a>
          <a
            :href="createURL(currentRefinement + 1)"
            @click.prevent="refine(currentRefinement + 1)"
            :class="['search-pagination-next', isLastPage && 'disabled']"
          >
            <SloIcon name="ArrowRight" size="sm" />
          </a>
        </template>
      </ais-pagination>

      <span v-if="nbPages > 1"> {{ page + 1 }} - {{ nbPages | comma }} </span>

      <a
        v-if="nbPages > 1 && tab === 'all'"
        :href="`#${group.slug}`"
        @click.prevent="$emit('view-all', group.slug)"
        class="text-uppercase fw-medium flex items-center"
      >
        {{ 'View All' | t }}
        <SloIcon name="ChevronRight" class="ml-xs" />
      </a>
    </template>
  </ais-stats>
</template>

<script>
import t from '../../main/i18n';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon
  },
  props: {
    tab: String,
    group: Object
  },
  filters: {
    comma(value) {
      if (typeof value === 'string') value = Number(value);
      try {
        return new Intl.NumberFormat(this.langcode).format(value);
      } catch (e) {
        return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }
    },
    t
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';
@import '../../../scss/mixins';

.search-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  > * + * {
    margin-left: 1.5rem;
  }

  > :first-child {
    margin-right: auto;
  }

  &-buttons {
    display: flex;
  }

  &-buttons a {
    position: relative;
    font-size: 1rem;
    width: 2.5em;
    height: 2.5em;
    color: $color-gray-900;
    border: currentColor 1px solid;
    border-radius: 3px;
    display: grid;
    place-content: center;
    padding: 0.5em;
  }

  &-buttons .slo-icon {
    width: 100%;
    height: 100%;
  }

  &-buttons a + a {
    margin-left: 0.625em;
  }

  &-buttons a:hover {
    border-color: $color-blue-400;
    background-color: $color-blue-400;
    color: $color-white;
  }

  &-buttons a.disabled {
    pointer-events: none;
    color: $color-gray-400;
  }
}
</style>
